<template>
<div v-if="hasHint" class="bg-primary-lightest p-4 rounded">
  <p class="text-sm" v-html="delivery.address_hint"></p>
</div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  computed: {
    ...mapGetters({
      delivery: 'settings/delivery',
    }),

    hasHint() {
      return this.delivery.address_hint.length > 0
    },
  },
}
</script>
